export default __webpack_public_path__ + "static/pearlogo-b078a2b3aa16fadac9c0de7ac07f4942.png";